import { FC } from 'react'
import { Segmented } from 'antd'
import { FiMoon, FiSun } from 'react-icons/fi'
import { ThemeMode, useThemeMode } from 'src/cms/layout/core/theme/ThemeModeProvider'

export const ThemeModeSelector: FC<{ className?: string }> = ({ className = 'me-2' }) => {
  const { mode, setMode } = useThemeMode()

  return (
    <Segmented
      value={mode}
      onChange={(value) => setMode(value as ThemeMode)}
      options={[
        { value: 'light', icon: <FiSun style={{ verticalAlign: '-2px' }} />, title: 'Light' },
        { value: 'dark', icon: <FiMoon style={{ verticalAlign: '-2px' }} />, title: 'Dark' },
      ]}
      className={className}
    />
  )
}
